<template>
  <section class="section">
    <div class="content">
      <h1 class="title" ref="title">
        <trans wrap="span" t="SECTION_HERO_TITLE">
          <br/><strong><label></label>{{"SECTION_HERO_TITLE_F".t()}}</strong>
        </trans>
      </h1>

      <a class="link" ref="button" target="_blank" href="https://app.kokoa.finance">
        <span>{{"SECTION_HERO_APP".t()}}</span>
      </a>

      <div ref="cards" class="content-cards">
        <div class="card">
          <span class="num">
            <svg viewBox="0 0 54 54"><path d="m27 1 2.548 5.828 3.918-5.011 1.019 6.279 5.04-3.88-.574 6.335 5.847-2.504-2.132 5.993 6.287-.971-3.556 5.274 6.33.623-4.755 4.224 5.977 2.177-5.657 2.91 5.247 3.595-6.202 1.41 4.188 4.788-6.358-.176 2.866 5.679-6.115-1.752 1.364 6.213-5.487-3.217-.224 6.357-4.515-4.48-1.797 6.101L27 47.332l-3.259 5.463-1.797-6.102-4.515 4.481-.224-6.357-5.487 3.217 1.364-6.213-6.115 1.752 2.866-5.679-6.359.176 4.19-4.787-6.203-1.411 5.247-3.595-5.657-2.91 5.977-2.177-4.755-4.224 6.33-.623-3.556-5.274 6.287.97-2.132-5.992 5.847 2.504-.575-6.335 5.041 3.88 1.02-6.28 3.917 5.012L27 1Z" fill="#FFF200" stroke="#5E5148" stroke-linejoin="round"/></svg>
            <label>1</label>
          </span>
          <div class="texts">
            <h3>
              {{"SECTION_HERO_CARD_1_TITLE".t()}}
            </h3>
            <p>
              {{"SECTION_HERO_CARD_1_DESC".t()}}
            </p>
          </div>
        </div>

        <div class="card">
          <span class="num">
            <svg viewBox="0 0 54 54"><path d="m27 1 2.548 5.828 3.918-5.011 1.019 6.279 5.04-3.88-.574 6.335 5.847-2.504-2.132 5.993 6.287-.971-3.556 5.274 6.33.623-4.755 4.224 5.977 2.177-5.657 2.91 5.247 3.595-6.202 1.41 4.188 4.788-6.358-.176 2.866 5.679-6.115-1.752 1.364 6.213-5.487-3.217-.224 6.357-4.515-4.48-1.797 6.101L27 47.332l-3.259 5.463-1.797-6.102-4.515 4.481-.224-6.357-5.487 3.217 1.364-6.213-6.115 1.752 2.866-5.679-6.359.176 4.19-4.787-6.203-1.411 5.247-3.595-5.657-2.91 5.977-2.177-4.755-4.224 6.33-.623-3.556-5.274 6.287.97-2.132-5.992 5.847 2.504-.575-6.335 5.041 3.88 1.02-6.28 3.917 5.012L27 1Z" fill="#FFF200" stroke="#5E5148" stroke-linejoin="round"/></svg>
            <label>2</label>
          </span>
          <div class="texts">
            <h3>
              {{"SECTION_HERO_CARD_2_TITLE".t()}}
            </h3>
            <p>
              {{"SECTION_HERO_CARD_2_DESC".t()}}
            </p>
          </div>
        </div>

        <div class="card">
          <span class="num">
            <svg viewBox="0 0 54 54"><path d="m27 1 2.548 5.828 3.918-5.011 1.019 6.279 5.04-3.88-.574 6.335 5.847-2.504-2.132 5.993 6.287-.971-3.556 5.274 6.33.623-4.755 4.224 5.977 2.177-5.657 2.91 5.247 3.595-6.202 1.41 4.188 4.788-6.358-.176 2.866 5.679-6.115-1.752 1.364 6.213-5.487-3.217-.224 6.357-4.515-4.48-1.797 6.101L27 47.332l-3.259 5.463-1.797-6.102-4.515 4.481-.224-6.357-5.487 3.217 1.364-6.213-6.115 1.752 2.866-5.679-6.359.176 4.19-4.787-6.203-1.411 5.247-3.595-5.657-2.91 5.977-2.177-4.755-4.224 6.33-.623-3.556-5.274 6.287.97-2.132-5.992 5.847 2.504-.575-6.335 5.041 3.88 1.02-6.28 3.917 5.012L27 1Z" fill="#FFF200" stroke="#5E5148" stroke-linejoin="round"/></svg>
            <label>3</label>
          </span>
          <div class="texts">
            <h3>
              {{"SECTION_HERO_CARD_3_TITLE".t()}}
            </h3>
            <p>
              {{"SECTION_HERO_CARD_3_DESC".t()}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$anime({
      targets: this.$refs.title.querySelectorAll("span > span, span > strong"),
      translateY: ["100%", 0],
      translateZ: 0,
      duration: 750,
      easing: "easeOutExpo",
      delay: (el, i) => 300 * i,
    })

    this.$anime({
      targets: this.$refs.title.querySelectorAll("label"),
      translateX: ["-100%", 0],
      translateZ: 0,
      duration: 750,
      easing: "easeOutExpo",
      delay: 300,
    });

    this.$anime({
      targets: this.$refs.button,
      translateY: ["50%", 0],
      translateZ: 0,
      opacity: [0, 1],
      duration: 750,
      easing: "easeOutExpo",
      delay: 1000,
    });

    this.$anime({
      targets: this.$refs.image,
      scale: [1.2, 1],
      opacity: [0, 1],
      duration: 750,
      easing: "easeOutExpo",
      delay: 1200,
    });

    this.$anime({
      targets: this.$refs.cards.querySelectorAll(".card"),
      scaleX: [1.5, 1],
      translateX: ["100%", 0],
      translateY: ["10%", 0],
      translateZ: 0,
      opacity: [0, 1],
      duration: 750,
      easing: "easeOutExpo",
      delay: (el, i) => 1200 + 200 * i,
    })
  }
}
</script>

<style scoped>
.section {
  background-color: #FFF42D;
  background-size: 1440px 1026px;
  background-image: url('../assets/pattern.png');
  background-blend-mode: multiply;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;
  padding: 4.6rem 6rem 3rem 6rem;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
}

.title {
  margin-top: 3rem;
  font-weight: 600;
  font-size: 4rem;
  line-height: 140%;
  text-align: center;

  & .wrap {
    display: inline-block;
    padding: 0 0.5rem;
    overflow: hidden;

    & span {
      display: inline-block;
    }
  }

  & strong {
    position: relative;
    z-index: 0;

    display: inline-block;
    font-weight: 800;
    color: #009e9e;

    & label {
      position: absolute;
      left: -0.5rem;
      right: -0.5rem;
      top: 0.5rem;
      bottom: 0.5rem;
      z-index: -1;
      background: rgba(247, 247, 250, 0.8);
    }
  }
}

.link {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 3.5rem;
  width: 25.4rem;
  height: 6rem;
  background: #F7F7FA;
  border: 0.2rem solid #7D6C60;
  box-shadow: 0.2rem 0.2rem 0 #B8AA9F;
  border-radius: 3rem;

  font-weight: 700;
  font-size: 2.8rem;
  line-height: 3.8rem;
  text-align: center;
  letter-spacing: -0.01em;
  color: #000000;
}

.content-cards {
  display: flex;
  justify-content: center;

  margin-top: -7rem;
  transform: translateY(15rem);
}

.card {
  display: flex;
  flex-direction: column;

  margin: 0 1rem;
  width: 27.7rem;
  height: 20rem;
  background: #F3ECE6;
  border: 0.2rem solid #A59E9E;
  box-shadow: 0.4rem 0.4rem 0 #A59E9E;
  border-radius: 2rem;

  & .num {
    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;
    margin-left: 2.8rem;
    margin-top: 2.2rem;
    width: 5.2rem;
    height: 5.2rem;

    & svg {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }

    & label {
      position: relative;
      z-index: 1;
      font-weight: 600;
      font-size: 3.1rem;
      line-height: 2.8rem;
      color: #5E5148;
    }
  }

  & .texts {
    margin-top: auto;
    padding: 0 2.8rem;

    & h3 {
      margin-bottom: 1.5rem;
      font-weight: 700;
      font-size: 3rem;
      line-height: 2rem;
      color: #000000;
    }

    & p {
      margin-bottom: 3rem;
      font-weight: 600;
      font-size: 2.4rem;
      line-height: 2.8rem;
      color: #5E5148;
    }
  }
}

@media (max-width: 425px) {
  .content {
    padding: 0rem 2.83rem 6rem 1.9rem;
  }

  .title {
    margin-top: 6rem;
    font-size: 2.2rem;
    line-height: 3.4rem;
    white-space: nowrap;
  }

  .link {
    margin-top: 6rem;
    background: #F7F7FA;
    border: 0.2rem solid #7D6C60;
    box-shadow: 0.2rem 0.2rem 0 #B8AA9F;
    border-radius: 3rem;

    font-size: 2rem;
    line-height: 2.7rem;
    letter-spacing: -0.01em;
  }

  .content-right {
    align-self: flex-end;

    margin-right: -1rem;
    margin-top: -5rem;
    width: 17rem;
  }

  .content-cards {
    flex-direction: column;

    margin-top: -2rem;
    transform: translateY(9rem);
  }

  .card {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin: 0.6rem 0;
    margin-left: -1rem;
    width: 112%;
    height: 6.2rem;
    border: 0.2rem solid #A59E9E;
    box-shadow: 0.3rem 0.3rem 0 #A59E9E;
    border-radius: 1.6rem;

    & .num {
      margin: 0;
      margin-left: 1.5rem;
      width: 3.6rem;
      height: 3.6rem;

      & label {
        font-size: 2rem;
      }
    }

    & .texts {
      display: flex;
      align-items: center;

      margin-top: 0;
      padding: 0;
      padding-left: 1.1rem;

      & h3 {
        margin: 0;
        font-size: 2.2rem;
      }

      & p {
        margin: 0;
        margin-left: 1rem;
        font-size: 1.6rem;
      }
    }
  }
} 
</style>



// WEBPACK FOOTER //
// src/components/SectionHero.vue